import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Image, useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CONTENT_IMAGE_PLACEHOLDER,
} from '../../../config/constants';

import './style.scss';

const LocationsSlider = ({ onClickShowMarker, title, buttonText, entities, type = 'articles', withBg = false }) => {
  const sliderRef = useRef();
  const { t } = useTranslation();
  const [sliderIsAtStart, setSliderIsAtStart] = useState(true);
  const [sliderIsAtEnd, setSliderIsAtEnd] = useState(false);

  const { width } = useWindowDimensions();
  const mobile = width < 768;
  const scrollOffset = mobile ? 300 : 600;

  const updateSliderStatus = () => {
    setTimeout(() => {
      setSliderIsAtStart(sliderRef.current.scrollLeft === 0);
      setSliderIsAtEnd(sliderRef.current.scrollLeft === sliderRef.current.scrollWidth);
    }, 150);
  };

  const slideBackwards = () => {
    sliderRef.current.scrollLeft = sliderRef.current.scrollLeft - scrollOffset;
    updateSliderStatus();
  };

  const slideForwards = () => {
    sliderRef.current.scrollLeft = sliderRef.current.scrollLeft + scrollOffset;
    updateSliderStatus();
  };

  const handleClick = (uuid, coordinates) => {
    onClickShowMarker(uuid, coordinates);
  };

  return (
    <div className="LocationsSlider">
      <div className="LocationsSlider__inner">
        <div className="LocationsSlider__inner__content">
          <ul
            className="LocationsSlider__inner__content__slider"
            ref={sliderRef}
            aria-label={t('components.locations_map.list')}>
            {entities && entities.map((entity) => {
              if (entity) {
                const name = entity.getIn(['name', 0, 'value'], '');
                const phone = entity.getIn(['field_phone', 0, 'value'], '');
                const addressLine1 = entity.getIn(['field_address', 0, 'address_line1'], '');
                const addressLine2 = entity.getIn(['field_address', 0, 'address_line2'], '');
                const postalCode = entity.getIn(['field_address', 0, 'postal_code'], '');
                const city = entity.getIn(['field_address', 0, 'locality'], '');
                const uuid = entity.getIn(['uuid', 0, 'value']);
                const coordinates = entity
                  .getIn(['field_geo_coordinates', 0, 'latlon'], '')
                  .split(',')
                  .map((x) => Number(x));
                const image = entity.getIn(['field_image', 0, 'styles', 'crop_4_3']);

                if (coordinates.length < 2) {
                  return null;
                }

                return (
                  <li className="LocationsSlider__inner__content__slider__item">
                    <button
                      type="button"
                      className="LocationsSlider__inner__content__slider__item__button"
                      key={uuid}
                      data-cardid={uuid}
                      onClick={() => handleClick(uuid, coordinates)}
                    >
                      <Image
                        lazyload
                        includeWebP
                        src={image || CONTENT_IMAGE_PLACEHOLDER}
                      />
                      <div className="LocationsSlider__inner__content__slider__item__text">
                        {name && (
                          <div className="LocationsSlider__inner__content__slider__item__title-wrapper">
                            <h3 className="u-word-break u-truncate--2">{name}</h3>
                            <i className="icon icon-arrow-right" />
                          </div>
                        )}
                        {addressLine1 && <div>{addressLine1}</div>}
                        {addressLine2 && <div>{addressLine2}</div>}
                        {postalCode && city && <div>{postalCode} {city}</div>}
                        {phone && <div>{phone}</div>}
                      </div>
                    </button>
                  </li>
                );
              }
            })}
          </ul>
        </div>

        {/* navigation */}
        <div className="LocationsSlider__navigation">
          <div className="LocationsSlider__navigation__prev" onClick={slideBackwards}>
            <div className={`icon icon-arrow-right-filled ${sliderIsAtStart && 'icon-variant-4'}`} />
          </div>

          <div className="LocationsSlider__navigation__next" onClick={slideForwards}>
            <div className={`icon icon-arrow-right-filled ${sliderIsAtEnd && 'icon-variant-4'}`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationsSlider;
